import { useRef, useMemo, useEffect } from 'react';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';
import FJAnimationSet from '../FJAnimationSet/FJAnimationSet';
import styles from './FJFake3dAnimation.module.less';
import PropTypes from 'prop-types';
import FJFake3dAnimationItem from './FJFake3dAnimationItem/FJFake3dAnimationItem';
import { ANIMATION_STYLE_LIST } from '../../../../config/dataConfig/FJFake3dData';

const FJFake3dAnimation = props => {
    const { animationStyle, onAnimationStyleChange } = props;
    const containerRef = useRef(null);
    const animationSetRef = useRef(null);
    const _onChange = type => {
        onAnimationStyleChange(type);
    };

    const arrowPositionClassName = useMemo(() => {
        const index = ANIMATION_STYLE_LIST.findIndex(item => item.type === animationStyle) % 4;
        return 'position' + index;
    }, [animationStyle]);
    const directions = useMemo(() => {
        return ANIMATION_STYLE_LIST.find(item => item.type === animationStyle)?.directions || [];
    }, [animationStyle]);
    useEffect(() => {
        if (animationSetRef.current && containerRef.current) {
            const AnimationSetContainer = animationSetRef.current.getContainer();

            // if (
            //     AnimationSetRect.top > scrollContainerRect.bottom ||
            //     AnimationSetRect.top - 111 < scrollContainerRect.top
            // ) {
            // const scrollTop = AnimationSetContainer.offsetTop - 111;
            const scrollTop = AnimationSetContainer.offsetTop - 111;
            containerRef.current.scrollTop(scrollTop, 'smooth');
            // }
        }
    }, [animationStyle]);
    const renderItem = () => {
        const renderItems = ANIMATION_STYLE_LIST.map(item => (
            <FJFake3dAnimationItem
                key={item?.type}
                item={item}
                selected={item.type === animationStyle}
                onClick={() => {
                    _onChange(item.type);
                }}
                directions={item.directions}
            />
        ));
        const index = ANIMATION_STYLE_LIST.findIndex(item => item.type === animationStyle);
        if (index === -1) {
            return renderItems;
        }
        let addIndex = (Math.floor(index / 4) + 1) * 4;
        if (addIndex > ANIMATION_STYLE_LIST.length) {
            addIndex = ANIMATION_STYLE_LIST.length;
        }
        renderItems.splice(
            addIndex,
            0,
            <FJAnimationSet
                key='FJAnimationSet'
                arrowPositionClassName={arrowPositionClassName}
                directions={directions}
                {...props}
                ref={animationSetRef}
            />,
        );

        return renderItems;
    };
    return (
        <>
            <FJVerticalScroller className={styles.animation_box} ref={containerRef}>
                {renderItem()}
            </FJVerticalScroller>
        </>
    );
};

FJFake3dAnimation.propTypes = {
    animationStyle: PropTypes.string,
    onAnimationStyleChange: PropTypes.func,
};
export default FJFake3dAnimation;
